import { OrderType } from '@modules/common'
import { nav } from '@stores/nav'
import { DimensionPaginatedHierarchyItemsUIStore } from '@stores/paginated-hierarchy-items/DimensionPaginatedHierarchyItemsUIStore'

import { action, observable } from 'mobx'
import { AddProductToOrderDataStore } from './AddProductToOrderDataStore'
import { getChannelName } from '@utils/get-channel-name'
import { stores } from '@stores'
import {
  ENHANCED_HIERARCHY_ELEMENT_HEIGHT,
  ENHANCED_PRODUCT_CARD_DIMENSIONS,
  PRODUCT_IMAGE_HEIGHT
} from '@modules/showroom/productCollection/constants/uiConstants'
import { ItemType } from '@stores/paginated-hierarchy-items/PaginatedHierarchyItemsUIStore'
import { checkEnhancedProductActiveStatus } from '@components/UI-Components/ProductCard/ProductStatusHook'

/**
 * This class is responsible for UI related data management it will modify store data as necessary to UI
 */
// Details

export class AddProductToOrderUIStore extends DimensionPaginatedHierarchyItemsUIStore<AddProductToOrderDataStore> {
  @observable currentViewConfig = null

  @action
  setCurrentViewConfig = () => {
    const {
      nav: {
        queryParams: { clientType }
      },
      productConfiguration: { getViewProductCardAttributes }
    } = stores
    const channelName = getChannelName(clientType)
    this.currentViewConfig = getViewProductCardAttributes(
      channelName,
      this.dataStore.currentViewName
    )
  }

  @action
  updateOrderCardDimensions = () => {
    if (this.dimensions) {
      const newHeight = this.cardDynamicContentHeight + PRODUCT_IMAGE_HEIGHT
      const newDim = {
        [ItemType.CATEGORY]: {
          height: ENHANCED_HIERARCHY_ELEMENT_HEIGHT
        },
        [ItemType.INDIVIDUAL]: {
          ...ENHANCED_PRODUCT_CARD_DIMENSIONS[this.dimensions],
          height: newHeight
        },
        [ItemType.PAGE]: {
          ...ENHANCED_PRODUCT_CARD_DIMENSIONS[this.dimensions],
          height: newHeight
        }
      }
      this.updateViewDimensions(newDim)
    }
  }

  @action
  prepareViewData = () => {
    this.dataStore.fetchAndPrepareFilterAttributesData(this.dataStore.currentViewName)
    this.dataStore.cnfGroupByUIStore.setGroupByAttributes(this.dataStore.currentViewName)
    this.dataStore.enhancedSortStore.setSortAttributesList(this.dataStore.currentViewName)
    this.calculateCardHeight(this.currentViewConfig)
    this.updateOrderCardDimensions()
  }

  @action
  addProductToOrder = (productId, doorOrderIds?, updateObjectStore?) => {
    return this.dataStore.addProductToOrder(productId, doorOrderIds, updateObjectStore)
  }

  @action
  removeProductFromOrderDetailsPopup = productId => {
    const {
      nav: {
        queryParams: { clientType, clientId }
      }
    } = stores
    const productIndex = this.dataStore.itemIndexObjectStore?.getIndexByKey(productId)
    const product = this.dataStore.itemIndexObjectStore.indexObjectMap.get(productIndex)
    const isProductActive = checkEnhancedProductActiveStatus(
      product,
      clientType,
      clientId
    )
    const groupId =
      productIndex > -1 ? this.getFocusedProductHierarchy(productIndex) : null
    return this.dataStore.removeProductToOrder(productId, groupId, !isProductActive, true)
  }

  @action
  removeProductToOrder = (
    productId,
    groupId?: string,
    isProductActive?: boolean,
    updateObjectStore?
  ) => {
    return this.dataStore.removeProductToOrder(
      productId,
      groupId,
      !isProductActive,
      updateObjectStore
    )
  }

  @action
  addAllProductToOrder = doorOrderIds => {
    const { orderType } = nav.queryParams
    if (orderType === OrderType.Client) {
      return this.dataStore.addAllProductsToOrder(doorOrderIds).then(resp => {
        return resp
      })
    } else {
      return this.dataStore.addAllProductsToDoorOrder(doorOrderIds[0]).then(resp => {
        return resp
      })
    }
  }

  @action
  removeAllProductFromOrder = doorOrderIds => {
    const { orderType } = nav.queryParams
    if (orderType === OrderType.Client) {
      return this.dataStore.removeAllProductsFromOrder(doorOrderIds).then(res => {
        this.removeAllInActiveProducts()
        return res
      })
    } else {
      return this.dataStore.removeAllProductsFromDoorOrder(doorOrderIds[0]).then(res => {
        this.removeAllInActiveProducts()
        return res
      })
    }
  }

  @action removeAllInActiveProducts = () => {
    this.dataStore.reloadPageGroupsAndProducts()
  }

  @action destroy(): void {
    super.destroy()
    this.dataStore.setInitialTotalProducts(0)
  }
}
